import { Gift } from 'lucide-react';

// Restyling Step 0 — Deliverable 4b
// Schermata informativa statica "Invita e guadagna".
// Nessuna logica referral, nessun endpoint backend: solo onboarding.
const STEPS = [
  'Condividi mAIstro con i tuoi colleghi artigiani',
  '5 colleghi attivano un piano a pagamento (Smart €29, Business €59 o Pro €79)',
  'Ottieni mesi gratis sul tuo piano in base alle attivazioni',
];

const REWARDS = [
  { range: '1-2 attivazioni', reward: '1 mese gratis sul tuo piano' },
  { range: '3-4 attivazioni', reward: '3 mesi gratis' },
  { range: '5+ attivazioni', reward: '6 mesi gratis (oppure piano Smart gratuito per 6 mesi se sei su Free)' },
];

export default function InvitaEGuadagna() {
  return (
    <div style={{
      flex: 1, minHeight: '100%', display: 'flex', alignItems: 'center',
      justifyContent: 'center', padding: '32px 20px',
    }}>
      <div style={{ width: '100%', maxWidth: 480, textAlign: 'center' }}>

        {/* Icona */}
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
          <Gift size={48} color="var(--zone-slate)" strokeWidth={1.6} />
        </div>

        {/* Titolo */}
        <h1 className="font-display" style={{ fontSize: 24, fontWeight: 700, color: 'var(--ink)', margin: '0 0 12px' }}>
          Invita e guadagna
        </h1>

        {/* Sottotitolo */}
        <p style={{ fontSize: 14, color: 'var(--ds-muted)', lineHeight: 1.6, margin: '0 auto', maxWidth: 420 }}>
          Consiglia mAIstro ai tuoi colleghi artigiani e ottieni mesi gratis sul tuo piano.
        </p>

        {/* Separatore */}
        <div style={{ height: 1, background: 'var(--ds-border)', margin: '28px auto', maxWidth: 320 }} />

        {/* Card reward */}
        <div style={{
          background: 'var(--chip)', border: '1px solid var(--ds-border)',
          borderRadius: 'var(--radius-card)', padding: '20px 22px', textAlign: 'left',
        }}>
          <div className="font-display" style={{ fontSize: 15, fontWeight: 600, color: 'var(--ink)', marginBottom: 16 }}>
            🎁 Come funziona
          </div>

          {/* Step numerati */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {STEPS.map((step, i) => (
              <div key={i} style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                <div style={{
                  width: 24, height: 24, borderRadius: '50%', background: 'var(--brand)',
                  color: 'white', fontSize: 12, fontWeight: 600, flexShrink: 0,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  {i + 1}
                </div>
                <div style={{ fontSize: 13, color: 'var(--ds-text)', lineHeight: 1.5, paddingTop: 2 }}>
                  {step}
                </div>
              </div>
            ))}
          </div>

          {/* Tiers reward */}
          <div style={{ marginTop: 18, paddingTop: 16, borderTop: '1px solid var(--ds-border)', display: 'flex', flexDirection: 'column', gap: 10 }}>
            {REWARDS.map((r) => (
              <div key={r.range} style={{ display: 'flex', gap: 10, alignItems: 'baseline' }}>
                <span style={{ fontSize: 11, fontWeight: 600, color: 'var(--brand)', minWidth: 96, flexShrink: 0 }}>
                  {r.range}
                </span>
                <span style={{ fontSize: 12.5, color: 'var(--ds-text)', lineHeight: 1.5 }}>
                  {r.reward}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Nota */}
        <div style={{ fontSize: 13, color: 'var(--ds-muted)', marginTop: 18, lineHeight: 1.5 }}>
          Il programma referral sarà attivo a breve. Torna qui per trovare il tuo link personale.
        </div>

        {/* Bottone disabilitato */}
        <button
          disabled
          style={{
            marginTop: 16, padding: '12px 24px', borderRadius: 'var(--radius-base)',
            background: 'var(--chip)', color: 'var(--ds-muted)', fontSize: 14,
            fontWeight: 500, border: '1px solid var(--ds-border)', cursor: 'default',
          }}
        >
          Il tuo link referral arriverà presto
        </button>
      </div>
    </div>
  );
}
